export const FETCH_ORDERAHEAD_REQUEST = 'FETCH_ORDERAHEAD_REQUEST'
export const FETCH_ORDERAHEADDATE_SUCCESS = 'FETCH_ORDERAHEADDATE_SUCCESS'
export const FETCH_ORDERAHEADTIME_SUCCESS = 'FETCH_ORDERAHEADTIME_SUCCESS'
export const FETCH_ORDERAHEAD_FALIURE = 'FETCH_ORDERAHEAD_FALIURE'
